import { createContext } from "react"
import {
    InitialAppMessage,
    InitialAppModal,
    InitialAppModalSimple,
    InitialUser,
} from "./constant"
import { Menu } from "Types/menu"
import { User } from "Types/user"
import { AppMessage, AppModal, AppModalSimple } from "Types/app"
import { Channel } from "Types/channel"

export const AppContext = createContext<{
    drawerOpen: boolean,
    toggleDrawer: () => void,
    user: User,
    mainList: Menu[],
    privilegeMap: {[key: string]: {[key: string]: boolean}},
    roleMap: {[key: string]: boolean},
    appMessage: AppMessage,
    handleChangeMessage: (appMessage: AppMessage) => void,
    activeMenu: Menu | null,
    handleChangeActiveMenu: (menu: Menu | null) => void,
    appModal: AppModal,
    appModalSimple: AppModalSimple,
    handleChangeModal: (appModal: AppModal) => void,
    handleChangeModalSimple: (appModalSimple: AppModalSimple) => void,
    weChatChannel: Channel | null,
}>({
    drawerOpen: true,
    toggleDrawer: () => {},
    user: InitialUser,
    mainList: [],
    privilegeMap: {},
    roleMap: {},
    appMessage: InitialAppMessage,
    activeMenu: null,
    handleChangeMessage: () => {},
    handleChangeActiveMenu: () => {},
    appModal: InitialAppModal,
    appModalSimple: InitialAppModalSimple,
    handleChangeModal: () => {},
    handleChangeModalSimple: () => {},
    weChatChannel: null,
})

export const AppProvider = AppContext.Provider
